var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_433)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.288574,
    y: 0.0297852,
    width: 26.9401,
    height: 26.9401,
    rx: 13.47,
    fill: "#FCFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0545654 13.3433C0.0545654 20.1561 5.0026 25.8213 11.474 26.9701V17.0729H8.04815V13.2668H11.474V10.2212C11.474 6.79539 13.6813 4.89291 16.8034 4.89291C17.7923 4.89291 18.8589 5.04479 19.8478 5.19667V8.699H18.0972C16.422 8.699 16.0417 9.53605 16.0417 10.6026V13.2668H19.696L19.0873 17.0729H16.0417V26.9701C22.5131 25.8213 27.4611 20.1572 27.4611 13.3433C27.4611 5.76422 21.2947 -0.436523 13.7579 -0.436523C6.22105 -0.436523 0.0545654 5.76422 0.0545654 13.3433Z",
    fill: "url(#paint0_linear_1_433)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_433",
    x1: 13.7579,
    y1: -0.436523,
    x2: 13.7579,
    y2: 26.9701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CD8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CD845"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_433"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.288574,
    y: 0.0297852,
    width: 26.9401,
    height: 26.9401,
    rx: 13.47,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.1fabb764456359dda2df968d1338e5ab.svg";
export { ForwardRef as ReactComponent };